import { CustomSingleSelectModel } from "../../../components/CustomSingleSelect"
import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetBankAccountTransactionListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    selectedCompany: CustomSingleSelectModel | undefined
    /** Kolon başlıklarının altındaki filtreler. */
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli kayıtlar. */
    ids?: string[]
}

export const initialGetBankAccountTransactionListPagingAndFilterRequest: GetBankAccountTransactionListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    selectedCompany: undefined,
    columnFilters: []
}